import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  Input,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import * as moment from 'moment';
import * as FileSaver from 'file-saver';
import { BookmarkApiService } from 'src/app/shared/services/customer-api/bookmark-api.service';
import { FeatureFlagsService } from 'src/app/shared/services/customer-api/feature-flags.service';
import { UserInfoService } from 'src/app/shared/services/user-info.service';
import { NewsArticle } from '../../news-newsfeed-interface/news-feed.interfaces';

@Component({
  selector: 'app-bookmark-manager',
  templateUrl: './bookmark-manager.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookmarkManagerComponent {
  @Input() newsfeed: NewsArticle[] = [];
  @Input() newstype: string;

  featureFlags$ = this.featureFlagsService.featureFlags$;

  constructor(
    public userInfo: UserInfoService,
    private featureFlagsService: FeatureFlagsService,
    private bookmarkApi: BookmarkApiService,
    private router: Router,
    private destroyRef: DestroyRef,
  ) {}

  exportBookmarkedArticles(articles: NewsArticle[]): void {
    const today = moment().format('YYYY-MM-DD_hh-mm-ss');
    const bookmarks = {
      bookmarks: articles.map((news) => news.id),
    };
    const bookmarksString = JSON.stringify(bookmarks);
    const blob = new Blob([bookmarksString], { type: 'application/json' });
    FileSaver.saveAs(blob, 'bookmarks_export_' + today + '.json');
  }

  importBookmarkedArticles(event: Event | null): void {
    if (event !== null) {
      const files = (event.target as HTMLInputElement).files;
      if (files && files[0]) {
        for (let i = 0; i < files.length; i++) {
          const reader = new FileReader();
          reader.onload = (e: ProgressEvent<FileReader>) => {
            const result = JSON.parse(e.target.result as string);
            this.bookmarkApi
              .importStars({
                bookmarks: result.bookmarks,
              })
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(() => {
                this.router.navigate([], {
                  queryParams: {
                    update: Math.random(),
                  },
                  queryParamsHandling: 'merge',
                });
              });
          };
          reader.readAsText(files[i]);
        }
      }
    }
  }
}
